import { render, staticRenderFns } from "./AddCredentialsCard.vue?vue&type=template&id=c0150212&scoped=true&"
import script from "./AddCredentialsCard.vue?vue&type=script&lang=js&"
export * from "./AddCredentialsCard.vue?vue&type=script&lang=js&"
import style0 from "./AddCredentialsCard.vue?vue&type=style&index=0&id=c0150212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0150212",
  null
  
)

export default component.exports